import React from 'react';
import { Icon, Image } from 'semantic-ui-react';

const twitterLogoStyle = {
  color: '#1dcaff',
};

const facebookLogoStyle = {
  color: '#3B5998',
};

export const TelegramIcon = props => {
  const { size } = props;
  return <Icon name="telegram" size={size} color="blue" />;
};

export const TwitchIcon = props => {
  const { size } = props;
  return <Icon name="twitch" size={size} color="purple" />;
};

export const TiktokIcon = () => {
  const style = { width: 15, height: 15, display: 'inline-block' };
  return <Image src="/icons/tik-tok.svg" style={style} />;
};

export const YoutubeIcon = props => {
  const { size } = props;
  return <Icon name="youtube play" size={size} color="red" />;
};

export const FacebookIcon = props => {
  const { size } = props;
  return <Icon name="facebook" size={size} style={facebookLogoStyle} />;
};

export const InstagramIcon = props => {
  const { size } = props;
  return <Icon name="instagram" size={size} color="pink" />;
};

export const TwitterIcon = props => {
  const { size } = props;
  return <Icon name="twitter" size={size} style={twitterLogoStyle} />;
};

export const PinterestIcon = props => {
  const { size } = props;
  return <Icon name="pinterest" size={size} color="red" />;
};

export const BlogIcon = props => {
  const { size } = props;
  return <Icon name="globe" size={size} color="blue" />;
};



/** WEBPACK FOOTER **
 ** ./src/components/dyzio-icons/index.js
 **/